import { createFileRoute, useParams } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { queryClient, trpc } from "~/utils/trpc";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { ContactsTable } from "./-pages/contactsTable";
import { FilterType } from "@quake/isomorphic";
import { useMemo } from "react";

const tableName = "contacts";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/contacts/")({
  loader: async () => {
    const tablePrefs = await queryClient.fetchQuery(trpc.users.getTablePreferences.queryOptions({ tableName }));
    return {
      initialDataFilters: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.filters
        : tablePrefs.originalFilters,
      baseDataFilters: tablePrefs.originalFilters,

      initialColumnsDisplay: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.columnsDisplay
        : tablePrefs.defaultColumnsDisplay,
      baseColumnsDisplay: tablePrefs.defaultColumnsDisplay,

      initialColumnsOrder: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.columnsOrder
        : tablePrefs.defaultColumnsOrder,
      baseColumnsOrder: tablePrefs.defaultColumnsOrder,

      activeSort: tablePrefs.activePreferenceId
        ? tablePrefs.prefs.find((pref: any) => pref.id === tablePrefs.activePreferenceId)?.sort
        : [],

      activePreferenceId: tablePrefs.activePreferenceId,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const {
    initialDataFilters,
    baseDataFilters,
    initialColumnsOrder,
    initialColumnsDisplay,
    baseColumnsOrder,
    baseColumnsDisplay,
    activeSort,
    activePreferenceId,
  } = Route.useLoaderData();
  const { datasetSlug } = useParams({ from: "/_dashboard/$datasetSlug" });

  useBreadCrumbs([{ title: "Contacts", link: `/${datasetSlug}/data/contacts` }]);

  const parsedFilters = useMemo(() => initialDataFilters as Record<string, FilterType>, [initialDataFilters]);
  const { data: views } = useQuery(trpc.entityViews.getViews.queryOptions({ entityType: "contacts" }));

  return (
    <ContactsTable
      initialDataFilters={parsedFilters}
      baseDataFilters={baseDataFilters}
      //
      initialColumnsDisplay={initialColumnsDisplay}
      baseColumnsDisplay={baseColumnsDisplay}
      //
      initialColumnsOrder={initialColumnsOrder}
      baseColumnsOrder={baseColumnsOrder}
      //
      views={views ?? []}
      activeSort={activeSort}
      activePreferenceId={activePreferenceId}
    />
  );
}
